import * as types from "../types";
import content from "../../assets/contentJson";
import occupationContent from "../../assets/occupationContentJson";
import verbiageContent from "../../assets/verbiageContentJson";

const initState = {
  isSaved: false,
  isSubmited: false,
  currentAction: "",
  screenName: "personalDetails",
  dataFilled: false,
  isSubmitedSuccess: false,
  loading: false,
  error: null,
  splashLoader: true,
  appContent: content,
  occupationDetails: occupationContent,
  cardList: [],
  bannerList: {},
  cardListFeteched: false,
  cardListDetails: {},
  errorContent: verbiageContent,
  multicardUrl: "",
  isGenericError: false,
  retryCount: 0,
  clickEvent: null,
  exitEvent: null,
  applicationBootFailed: false,
  errorMessage: '',
  appLoader: false,
  // appBootStatus: { isContent: false, isBankList: false, isMasterData: false, isCityData: false },
  webCamPresent: false
};

const AppStateReducer = (state = initState, action) => {
  switch (action.type) {
    case types.LOADING_VIEW_STATE:
      return {
        ...state,
        loading: action.value, // SET LOADING STATE TO TRUE
        error: null, // SET ERROR TO FALSE [ IN CASE OF LOAD AFTER ERROR ]
      };
    case types.SPLASH_VAL_TIMER:
      return {
        ...state,
        splashLoader: action.value, // SET LOADING STATE TO TRUE
        error: null, // SET ERROR TO FALSE [ IN CASE OF LOAD AFTER ERROR ]
      };

    case types.UPDATE_CURRENT_APP_STATE:
      return {
        ...state,
        isSaved: action.payload.isSaved,
        currentAction: action.payload.currentAction,
        screenName: action.payload.screenName || state.screenName,
        isSubmited: action.payload.isSubmited,
        isSubmitedSuccess: action.payload.isSubmitedSuccess,
        dataFilled: action.payload.dataFilled,
        loading: action.payload.loading,
        // error: action?.error,
        isUserRetrieve: action.payload.isUserRetrieve,
        isSprintTrackRetrieve: action.payload.isSprintTrackRetrieve,
        onSd2SuccTelOptSndFail: action.payload.onSd2SuccTelOptSndFail,
        reKycIntimation: action.payload.reKycIntimation,
        isFfnSubmitedSuccess: action.payload.isFfnSubmitedSuccess
      };
    case types.SET_APP_CONTENT:
      return {
        ...state,
        appContent: action.payload,
      };
    case types.SET_SUBMIT_SUCCESS:
      return {
        ...state,
        loading: false,
        isSubmitedSuccess: true,
      };
    case types.SET_OCC_CONTENT:
      return {
        ...state,
        occupationDetails: action.payload,
      };
    case types.RESET_BUTTON_PROGRESS:
      return {
        ...state,
        loading: false,
        isSubmitedSuccess: false,
      };
    case types.SET_CND_CONTENT:
      return {
        ...state,
        // cardListDetails: action.payload.selectedCard,
        cardList: action.payload.cardList,
        bannerList: action.payload.bannerContent, 
        cardListFeteched: true,
      };
    case types.SET_SELECTED_CARD_DETAILS:
      return {
        ...state,
        cardListDetails: action.payload.selectedCard,
      };
    case types.SET_ERR_CONTENT:
      return {
        ...state,
        errorContent: action.payload,
      };
    case types.VIEW_ERROR:
      return {
        ...state,
        error: action.error
      }
    case types.GENERIC_ERROR:
      return {
        ...state,
        isGenericError: action.payload?.isGenericError,
        retryCount: action.payload?.handleClick === undefined ? state.retryCount : (action.payload?.handleClick === null ? 0 : state.retryCount + 1),
        clickEvent: action.payload?.handleClick,
        exitEvent: action.payload?.exitEvent,
        errorMessage: action.payload?.errorMessage
      }
    case types.SET_BOOT_APP_ERROR:
      return {
        ...state,
        applicationBootFailed: action.payload
      }
    case types.LOADING_APP_STATE:
      return {
        ...state,
        appLoader: action.payload
      }
    // case types.APP_BOOT_STATUS:
    //   return {
    //     ...state,
    //     appBootStatus: { ...state.appBootStatus, ...action.payload }
    //   }
    case types.SET_WEBCAM_STATUS:
      return {
        ...state,
        appBootStatus: { ...state.appBootStatus, ...action.payload }
      }
    case types.RESET_APP:
      return {
        ...state,
        isSaved: initState.isSaved,
        currentAction: initState.currentAction,
        screenName: initState.screenName,
        isSubmited: initState.isSubmited,
        isSubmitedSuccess: initState.isSubmitedSuccess,
        dataFilled: initState.dataFilled,
        loading: initState.loading,
        // error: action?.error,
        isUserRetrieve: initState.isUserRetrieve,
        isSprintTrackRetrieve: initState.isSprintTrackRetrieve,
        onSd2SuccTelOptSndFail: initState.onSd2SuccTelOptSndFail,
        reKycIntimation: initState.reKycIntimation,
        isFfnSubmitedSuccess: initState.isFfnSubmitedSuccess,
        
      };
    default:
      return state;
  }
};

export default AppStateReducer;
